<template>
  <div class="users">
    <template
      v-if="tableItems.length"
    >
      <p class="users__title h3">
        Чёрный список
      </p>

      <div class="users__panel">
        <BaseInput
          v-model="searchValue"
          placeholder="Поиск по всем параметрам"
          isSearch
          class="users__input"
          @enter="onSearch"
        />
      </div>

      <AppTable
        :fields="tableFields"
        :items="tableItems"
        class="users__table"
        @sort="onSortTable"
      >
        <template #name="{ id, name }">
          <BaseLink :href="`/user/${id}`">
            {{ name }}
          </BaseLink>
        </template>
        <template #button="{ id }">
          <button
            class="users__unblock"
            @click="onUnblock(id)"
          >Разблокировать</button>
        </template>
      </AppTable>

      <div class="users__bottom">
        <RouterLink to="users" class="users__link">
          Все пользователи
        </RouterLink>
        <AppPagination
          v-if="(paginationTotal / paginationPerPage) > 1"
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
        />
      </div>
    </template>

    <p v-else class="h3">Черный список пуст.</p>
  </div>
</template>

<script>
import BaseInput from '@/components/Base/BaseInput'
import AppTable from '@/components/AppTable'
import AppPagination from '@/components/Base/AppPagination'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'black-list',
  components: {
    BaseLink,
    AppPagination,
    AppTable,
    BaseInput
  },
  data () {
    /**
     * @property {Array} tableFields                                  - Заголовки таблицы
     * @property {Array} tableItems                                   - Контент таблицы
     * @property {String} searchValue                                 - Поле поиска
     * @property {Number} paginationCurrent                           - текущая страница
     * @property {Number} paginationTotal                             - общее кол-во записей в бд
     * @property {Number} paginationPerPage                           - количество строк в таблице
     * @property {String} order                                       - сортировка по возрастанию\убыванию
     * @property {String} sort                                        - свойство по которому будет сортировка
     */
    return {
      tableFields: [
        { key: 'name', label: 'Имя', sortable: true, slot: true },
        { key: 'username', label: 'Логин', sortable: true },
        { key: 'email', label: 'Почта', sortable: true },
        { key: 'createdAt', label: 'Дата', sortable: true },
        { key: 'button', label: '', slot: true }
      ],
      tableItems: [],
      searchValue: '',
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10,
      order: 'DESC',
      sort: 'id'
    }
  },
  computed: {
    /**
     * Тело запроса
     */
    fetchUsersRequestBody () {
      return {
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        searchBy: this.searchValue,
        sort: this.sort,
        order: this.order
      }
    }
  },
  watch: {
    /**
     * Отслеживанию изменение св-ва и подтягиваю новые данные таблицы
     */
    paginationCurrent: 'fetchUsers'
  },
  async created () {
    await this.fetchUsers()
  },
  methods: {
    /**
     * Подтягиваю данные таблицы по api
     */
    async fetchUsers () {
      const { data } = await this.$api.user.blackList(this.fetchUsersRequestBody)

      const result = []
      const list = data.list ?? []
      /* Записал общее колво пользователей */
      this.paginationTotal = data.pages * this.paginationPerPage

      for (const item of list) {
        result.push({
          id: item.id,
          name: item.name,
          username: item.username,
          email: item.email,
          createdAt: item.createdAt
        })
      }

      this.tableItems = result
    },
    /**
     * Записал новое значение поиска
     */
    async onSearch () {
      await this.fetchUsers()
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchUsers()
    },
    /**
     * Разблокировать пользователя
     */
    async onUnblock (id) {
      try {
        await this.$api.user.unblock(id)
        await this.fetchUsers()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.users {
  &__panel {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  &__input {
    max-width: 640px;
  }
  &__btn {
    padding: 0 20px;
  }

  &__table {
    margin-top: 40px;
  }

  &__bottom {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__link {
    display: block;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    color: #C2C2C2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__unblock {
    font-weight: bold;
    font-size: 16px;
    color: #2A9C43;
    cursor: pointer;
    border: none;
    background: transparent;
  }
}
</style>
